// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"45220c61","317":"cd57c296","413":"864e568b","917":"d7153086"}[chunkId] + ".chunk.js";
};